
import React from "react";
import renderChildren from "../renderChildren";

export default function IfNode({
  condition,
  children,
  node,
  context,
}: any) {
  if (!condition) return null;

  if (node?.children?.length) {
    return <>{renderChildren(node.children, context)}</>;
  }

  return <>{children}</>;
}
